import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
export class NyukyoshaShomeiViewModel {
    constructor(model) {
        this.model = model;
    }
    model;
    get shomeiNo() {
        return this.model.shomeiNo;
    }
    get shomeiKbName() {
        return this.model.shomeiKbName;
    }
    get shinseiYmd() {
        return dayjs(this.model.sinseiYmd, "YYYY/MM/DD h:mm:tt").format("YYYY/MM/DD");
    }
    get shomeiStatusName() {
        return this.model.shomeiStatusName;
    }
    get shomeiBikou() {
        return this.model.shomeiBikou;
    }
}
